import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { previewPages, previewPoints } from '../data/kit';
import { CTAButton, Section, SectionHeader } from './Shared';
const arrowClass = 'flex h-11 w-11 items-center justify-center rounded-full bg-brand-violet text-brand-cream transition-[transform,background-color,opacity] duration-150 ease-out hover:-translate-y-px hover:bg-brand-violet/90 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-orange disabled:pointer-events-none disabled:opacity-30';

/** Galería deslizable con páginas reales del kit. */
export function MaterialPreview() {
  const scrollerRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const goTo = (index: number) => {
    const scroller = scrollerRef.current;
    const item = scroller?.children[index] as HTMLElement | undefined;
    if (!scroller || !item) return;
    scroller.scrollTo({
      left: item.offsetLeft - (scroller.clientWidth - item.offsetWidth) / 2,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const center = scroller.scrollLeft + scroller.clientWidth / 2;
    let closest = 0;
    Array.from(scroller.children).forEach((child, index) => {
      const el = child as HTMLElement;
      const best = scroller.children[closest] as HTMLElement;
      if (Math.abs(el.offsetLeft + el.offsetWidth / 2 - center) < Math.abs(best.offsetLeft + best.offsetWidth / 2 - center)) {
        closest = index;
      }
    });
    setActive(closest);
  };
  return <Section id="material" tone="white" data-id="element-171" data-mp="27atc2a5ra85x">
      <SectionHeader title="Mirá el material por dentro" subtitle="Recorré sus páginas y descubrí las ideas que van a crear juntos." data-id="element-172" data-mp="22j1qke1gismn" />

      <ul ref={scrollerRef} onScroll={handleScroll} aria-label="Páginas de muestra del kit" className="no-scrollbar relative -mx-5 mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 md:-mx-8 md:gap-6 md:px-8" data-id="element-173" data-mp="1erec4vldta19">
        {previewPages.map((page, index) => <li key={page.src} className="w-[78%] shrink-0 snap-center sm:w-[46%] lg:w-[calc((100%-3rem)/3)]" aria-label={`Página ${index + 1} de ${previewPages.length}: ${page.title}`} data-id="element-174" data-mp="3etdvctfg71dg" data-mpi={index}>
            <img src={page.src} alt={`Página de muestra: ${page.title} (${page.source})`} loading="lazy" draggable={false} className="h-auto w-full rounded-2xl bg-brand-cream shadow-soft ring-1 ring-brand-violet/10" data-id="element-175" data-mp="2qy1bgjgqs0kf" />
            <p className="mt-3 text-xs font-bold tracking-wide text-brand-orangeDark" data-id="element-176" data-mp="34xsmcbbyp0u7">{page.source}</p>
            <p className="font-display text-lg font-bold leading-tight text-brand-violet" data-id="element-177" data-mp="g5zwtbweyeha">{page.title}</p>
          </li>)}
      </ul>

      <div className="mt-4 flex items-center justify-center gap-5" data-id="element-178" data-mp="k58mo5oc1s7k">
        <button type="button" onClick={() => goTo(active - 1)} disabled={active === 0} aria-label="Página anterior" className={arrowClass} data-id="element-179" data-mp="24o1a9i6n92s9">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-180" data-mp="20plr5pdooek4" />
        </button>
        <span className="min-w-[56px] text-center text-sm font-bold tabular-nums text-brand-violet" aria-live="polite" data-id="element-181" data-mp="1vvr206fb77dn">
          {active + 1} / {previewPages.length}
        </span>
        <button type="button" onClick={() => goTo(active + 1)} disabled={active === previewPages.length - 1} aria-label="Página siguiente" className={arrowClass} data-id="element-182" data-mp="1lyv0ikntvlil">
          <ChevronRightIcon className="h-5 w-5" data-id="element-183" data-mp="1cyptwcqgkr5h" />
        </button>
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl gap-3 md:grid-cols-3 md:gap-6" data-id="element-184" data-mp="17zllhobcyxg7">
        {previewPoints.map(point => <li key={point} className="flex items-start gap-2.5 text-base font-medium text-brand-ink md:justify-center md:text-center" data-id="element-185" data-mp="37amky4kznv00">
            <span className="font-bold text-brand-orangeDark" aria-hidden="true" data-id="element-186" data-mp="32b0ce8g3v2xj">
              ✓
            </span>
            <span data-id="element-187" data-mp="240s24hs5c3ma">{point}</span>
          </li>)}
      </ul>

      <div className="mt-10 text-center" data-id="element-188" data-mp="23yxrbwal9rvx">
        <CTAButton data-id="element-189" data-mp="1q1se9ccgjsr6">QUIERO CREAR EN FAMILIA →</CTAButton>
      </div>
    </Section>;
}